import * as React from 'react';
import { Grid, Typography, Button, Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import WineryForm from '../winery/WineryForm';

//#region UI configuration
const strings = {
    title: '🍇 VinVoir',
    addButton: '+ Add new Winery',
    success: 'Winery savad, thanks'
}
//#endregion

//#region Props & State
interface AppProps { }
interface AppState {
    showForm: boolean;
    info: string | null;
}

const initialState: AppState = {
    showForm: false,
    info: null
}
//#endregion

class App extends React.Component<AppProps, AppState> {

    constructor(props: AppProps) {
        super(props);

        this.state = initialState;
    }

    render() {
        const { showForm, info } = this.state;
        return (
            <React.Fragment>
                <Grid container={true} justify="center" alignContent="center" alignItems="center" style={{ height: '100%' }} direction="column" spacing={16}>
                    <Grid item={true}>
                        <Typography variant="headline">{strings.title}</Typography>
                    </Grid>
                    <Grid item={true}>
                        <Button variant="raised" color="primary" onClick={() => this.setState({ showForm: true })}>{strings.addButton}</Button>
                    </Grid>
                </Grid>

                {showForm &&
                    <WineryForm
                        onItemSaved={() => { this.setState({ showForm: false, info: strings.success }) }}
                        onCancelItemForm={() => this.setState({ showForm: false })}
                    />
                }

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={!!info}
                    autoHideDuration={6000}
                    onClose={() => { this.setState({ info: null }) }}
                    message={<span>{info}</span>}
                    action={[
                        <IconButton
                            key="close"
                            color="inherit"
                            onClick={() => { this.setState({ info: null }) }}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}
                />
            </React.Fragment>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/modules/app/App.tsx